import "./zoomto.css";
import { useZoomToAnimal } from "src/hooks/useZoomToAnimal";

const ZoomTo = () => {
  const zoomToAnimal = useZoomToAnimal();

  return (
    <button className="zoom-to-button" onClick={zoomToAnimal}>
      Zoom To Animal
    </button>
  );
};

export default ZoomTo;
